import PropTypes from 'prop-types';
// @mui
import {
    TableRow,
    TableCell,
    TableBody,
    Stack,
    Typography,
    Paper,
    Table,
    Container,
    Button,
    CardContent,
    TableContainer,
    TableHead,
    Checkbox,
    Select,
    ToggleButtonGroup,
    ToggleButton,
    InputLabel, MenuItem, FormControl, Input, Hidden, Link
} from '@mui/material';
import {useEffect, useRef, useState} from "react";
import {filter} from "lodash";
import {JournalListHead} from "../journal";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
    Downloading,
    Looks,
    PanoramaFishEye,
    Remove,
    RemoveCircleOutline, RemoveCircleOutlined,
    Upload,
    UploadFileOutlined,
    Warehouse
} from "@mui/icons-material";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import TextField from "@mui/material/TextField";
import FileUploadButton from "./FileUploadButton";
import {useGetTechMapByStatementIdQuery} from "../../../store/grc/grcApi";

// ----------------------------------------------------------------------

StudentGradeEditTable.propTypes = {
    students: PropTypes.array.isRequired,
    useStatementsView: PropTypes.bool.isRequired,
    usePracticeView: PropTypes.bool,
    controlType: PropTypes.number,
    prohibitSessionStatementsEditing: PropTypes.bool,
    noPrimaryGrade: PropTypes.bool,
    noExtraGrade: PropTypes.bool,
    lessonDate: PropTypes.object,
    pairNumber: PropTypes.number,
    hasTechMap: PropTypes.bool,
    statementId: PropTypes.number,
    techMap: PropTypes.object
};

// ----------------------------------------------------------------------


export default function StudentGradeEditTable(props) {
    const [refresh, setRefresh] = useState(false);
    const action = useRef(null);
    const [checkUncheckAllState, setCheckUncheckAllState] = useState(true);
    const grcExamMaxGrade = 100; // 36; // временно отключено

    function checkUncheckAllStateChanged(value) {
        for (let i = 0; i < props.students.length; i += 1) {
            props.students[i].attended = value;
        }

        setCheckUncheckAllState(value);
        console.log(`check/uncheck all to state ${value}`);
    }

    function inverseAttendanceForAll() {
        for (let i = 0; i < props.students.length; i += 1) {
            props.students[i].attended = !props.students[i].attended;
        }

        applyVisualChanges();
    }

    function setExtraGradeType(row, value) {
        row.extraGradeType = value;
        applyVisualChanges();
    }

    function certificateTypeName(id) {
        switch (id) {
            case 0:
                return 'Справка';
            case 1:
                return 'Распоряжение деканата';
            case 2:
                return 'Заявление';
            case 3:
                return 'График дежурств';
            default:
                return '-';
        }
    }

    function handleGradeChange(row, value, specialGrade = null) {
        if (props.hasTechMap && !specialGrade) {
            value = numbersOnly(value);
            if (parseFloat(value) > grcExamMaxGrade)
                value = grcExamMaxGrade.toString();
            
            row.points = value ? parseFloat(value) : null;
            row.grade = null;
            row.gradeId = null;
            row.newPointsGrade = calculateNewPointsGrade(row, value);
        } else if (row.grade !== undefined && row.grade !== null) { // в душе не чаю - что это за странное условие
            row.grade = value;
            row.points = null;
        } else {
            row.gradeId = value;
            row.points = null;
        }

        applyVisualChanges()
    }
    
    function calculateNewPointsGrade(row, value) {
        if (!props.hasTechMap)
            return 0;
        
        const techMap = props.techMap;
        if (!techMap)
            return 0;
        
        const sumOfPoints = row.precalculatedGrsPoints + parseFloat(value.toString(), 10);
        if (sumOfPoints >= techMap.conversionRangeGrade5From) {
            return 5;
        } 
        
        if (sumOfPoints >= techMap.conversionRangeGrade4From) {
            return 4;
        } 
        
        if (sumOfPoints >= techMap.conversionRangeGrade3From) {
            return 3;
        } 
        
        if (sumOfPoints >= techMap.conversionRangeGrade2From) {
            return 2;
        } 
        
        return 0;
    }

    function handleExtraGradeChange(row, value) {
        row.extraGrade = value;
        applyVisualChanges()
    }

    function attendedChanged(row, value) {
        row.attended = value;
        applyVisualChanges();
    }

    function applyVisualChanges() {
        setRefresh(!refresh);
    }

    function isCourseWork() {
        return (props.controlType === 3 || props.controlType === 4)
            && props.useStatementsView
            && props.usePracticeView !== true;
    }

    function toDateString(date) {
        if (date === null)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function numbersOnly(input) {
        if (!input)
            return '';
        
        input = input.toString();

        const allowedSymbols = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ',', '.'];
        let result = '';
        input.split('').forEach((symbol, index) => {
            if (allowedSymbols.includes(symbol)) {
                result += symbol;
                // if (symbol === ',' || symbol === '.' && input.length === index + 1) {
                //     result += '0';
                // }
            }
        });

        result = result.replace(',', '.');

        return result;
    }

    return (
        <Stack spacing={2}>
            <Stack direction="row" justifyContent={"right"} spacing={2}>
                {!props.useStatementsView
                    ? <>
                        <FormControlLabel control={<Checkbox defaultChecked
                                                             checked={checkUncheckAllState}
                                                             onChange={(event, value) => checkUncheckAllStateChanged(value)}/>}
                                          label="Отметить всех/снять выделение"/>
                        <Button variant={"outlined"} onClick={() => inverseAttendanceForAll()}>Инверсия</Button>
                    </>
                    : <></>}
            </Stack>

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <Typography>#</Typography>
                        </TableCell>
                        <TableCell>
                            <Typography>ФИО</Typography>
                        </TableCell>
                        {props.noPrimaryGrade !== true
                            ? <TableCell>
                                <Typography>{props.hasTechMap ? 'Баллы' : 'Оценка'}</Typography>
                            </TableCell>
                            : <></>}
                        {!props.useStatementsView && props.noExtraGrade !== true
                            ? (<TableCell>
                                <Typography>Доп. оценка</Typography>
                            </TableCell>)
                            : <></>}
                        {!props.useStatementsView
                            ? (<TableCell>
                                <Typography>Присутствие</Typography>
                            </TableCell>)
                            : <></>}
                        {isCourseWork()
                            ? <TableCell align={"right"}>Рецензия/Работа</TableCell>
                            : <></>}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.students?.map((row, index) => {
                        const {
                            studentId,
                            lastName,
                            firstName,
                            middleName,
                            attended,
                            grade,
                            gradeId,
                            points,
                            notAllowed,
                            extraGrade,
                            extraGradeType,
                            skippedHours,
                            totalHours,
                            certificatesOfSkipping,
                            registryDocumentGuid,
                            registryDocumentNumber,
                            registryDocumentDate,
                            preliminaryGradeName,
                            preliminaryGradeId,
                            preliminaryGrcGrade,
                            isByAverage
                        } = row;

                        let byAverage = row.isByAverage ?? false;
                        const filteredCertificates = certificatesOfSkipping?.filter((item) => item.fromDate <= props.lessonDate && item.toDate >= props.lessonDate);

                        return (<TableRow key={studentId}
                                          hover
                                          style={{cursor: 'pointer'}}
                                          onClick={(event) => {
                                              if (event.target.tagName === "TD")
                                                  attendedChanged(row, !attended)
                                          }}>
                            <TableCell>
                                <Typography fontWeight="bold">{index + 1}</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography fontWeight="bold">{lastName}</Typography>
                                <Typography>{firstName} {middleName}</Typography>
                                {!props.useStatementsView ?
                                    (
                                        <Typography
                                            fontSize="small">{skippedHours}/{totalHours} ({(totalHours === 0 ? 0 : (skippedHours * 100 / totalHours)).toFixed(2)}%
                                            пропусков)</Typography>
                                    )
                                    : null
                                }
                                {certificatesOfSkipping !== undefined && certificatesOfSkipping !== null && certificatesOfSkipping.length > 0
                                    ? filteredCertificates
                                        .map((item) => {
                                            return <Typography fontSize={"small"}
                                                               color={"orange"}>Имеется {certificateTypeName(item.documentType).toLowerCase()} с {toDateString(item.fromDate)} ({item.fromPair} пара)
                                                по {toDateString(item.toDate)} ({item.toPair} пара)</Typography>
                                        })
                                    : <></>}
                            </TableCell>
                            {props.noPrimaryGrade !== true
                                ? <TableCell>
                                    <Stack spacing={2}>
                                        {notAllowed
                                            ? <><Typography color={'error'}>Не допущен(а)</Typography></>
                                            : <></>}
                                        {!props.hasTechMap
                                        ? <ToggleButtonGroup orientation="horizontal"
                                                           exclusive
                                                           fullWidth
                                                           size={"small"}
                                                           value={grade ?? gradeId}
                                                           aria-label="Оценка"
                                                           color="primary"
                                                           disabled={props.prohibitSessionStatementsEditing || notAllowed || (registryDocumentGuid !== null && registryDocumentGuid !== undefined)}
                                                           onChange={(event, value) => handleGradeChange(row, value)}>
                                            <ToggleButton value={5} area-label="Отлично"
                                                          color="success">{props.controlType !== 1 ? '5' : 'Зачтено'}</ToggleButton>
                                            {props.controlType !== 1
                                                ? <ToggleButton value={4} area-label="Хорошо"
                                                                color="success">4</ToggleButton>
                                                : <></>}
                                            {props.controlType !== 1
                                                ? <ToggleButton value={3} area-label="Удовлетворительно"
                                                                color="warning">3</ToggleButton>
                                                : <></>}
                                            <ToggleButton value={2} area-label="Неудовлетворительно"
                                                          color="error">{props.controlType !== 1 ? '2' : 'Не зачтено'}</ToggleButton>
                                            {props.useStatementsView
                                                ?
                                                <ToggleButton value={6} area-label="н/д"
                                                              color="error">н/д</ToggleButton>
                                                : <></>}
                                            {props.useStatementsView
                                                ?
                                                <ToggleButton value={7} area-label="н/я"
                                                              color="error">н/я</ToggleButton>
                                                : <></>}
                                            <ToggleButton value={1} area-label="-" color="info">-</ToggleButton>
                                        </ToggleButtonGroup>
                                            : <Stack direction="row" 
                                                     alignItems="center"
                                                     spacing={0.5} 
                                                     fullWidth>
                                                <TextField size={"small"}
                                                           disabled={props.prohibitSessionStatementsEditing || notAllowed /* || (registryDocumentGuid !== null && registryDocumentGuid !== undefined) */ }
                                                           value={(props.hasTechMap ? points : grade) ?? ""}
                                                           onChange={(event) => handleGradeChange(row, event.target.value)} />

                                                <ToggleButtonGroup orientation="horizontal"
                                                                   exclusive
                                                                   size={"small"}
                                                                   value={grade ?? gradeId}
                                                                   onChange={(event, value) => handleGradeChange(row, value, value)}
                                                                   aria-label="Оценка"
                                                                   color="primary"
                                                                   disabled={props.prohibitSessionStatementsEditing || notAllowed || (registryDocumentGuid !== null && registryDocumentGuid !== undefined)}>
                                                    <ToggleButton value={7}
                                                                  size={'small'}
                                                                  area-label="н/я"
                                                                  color="error">н/я</ToggleButton>
                                                </ToggleButtonGroup>
                                            </Stack>
                                        }

                                        {preliminaryGradeId > 1 && props.useStatementsView && false // temporary disabled
                                            ? <FormControlLabel control={<Checkbox size={'small'} value={byAverage} onChange={(event, checked) => { row.isByAverage = checked; byAverage = checked; applyVisualChanges()}}/>}
                                                                label={<Typography size={'small'}>Оценка по среднему баллу: {preliminaryGradeName}</Typography>}/>
                                            : <></>}

                                        {row.newPointsGrade && !row.gradeId ? <Typography fontSize={'small'}>Оценка: {row.newPointsGrade}</Typography> : <></>}
                                        
                                        {preliminaryGrcGrade
                                            ? <Typography fontSize={'small'}>Предварительная оценка: {preliminaryGrcGrade}</Typography>
                                            : <></>}

                                        {registryDocumentGuid !== null && registryDocumentGuid !== undefined
                                            ? <Typography fontSize={'small'}>Перезачтено на основании документа
                                                <Link href={`https://fs.kubsau.ru/File/${registryDocumentGuid}`}
                                                      target={'_blank'}>
                                                    {` ${registryDocumentNumber} от ${toDateString(registryDocumentDate)}`}</Link>
                                            </Typography>
                                            : <></>}

                                        {
                                            props.usePracticeView
                                                ? <FileUploadButton existingFileUrl={row.attestationListUrl}
                                                                    maxFileSize={200 * 1024}
                                                                    title={'Аттестационный лист'}
                                                                    uploadingEnabled
                                                                    onFileUploaded={(newUrl, guid) => {
                                                                        row.attestationListUrl = newUrl;
                                                                        row.attestationListGuid = guid;
                                                                        applyVisualChanges()
                                                                    }}
                                                                    onFileDelete={() => {
                                                                        row.attestationListUrl = null;
                                                                        row.attestationListGuid = null;
                                                                        applyVisualChanges();
                                                                    }}/>
                                                : <></>}

                                        {
                                            props.usePracticeView
                                                ? <FileUploadButton existingFileUrl={row.reportUrl}
                                                                    maxFileSize={2 * 1024 * 1024}
                                                                    title={'Отчёт'}
                                                                    uploadingEnabled
                                                                    onFileUploaded={(newUrl, guid) => {
                                                                        row.reportUrl = newUrl;
                                                                        row.reportGuid = guid;
                                                                        applyVisualChanges()
                                                                    }}
                                                                    onFileDelete={() => {
                                                                        row.reportUrl = null;
                                                                        row.reportGuid = null;
                                                                        applyVisualChanges();
                                                                    }}/>
                                                : <></>}

                                        {
                                            props.usePracticeView
                                                ? <FileUploadButton existingFileUrl={row.documentsUrl}
                                                                    maxFileSize={2 * 1024 * 1024}
                                                                    title={'Документы'}
                                                                    uploadingEnabled
                                                                    onFileUploaded={(newUrl, guid) => {
                                                                        row.documentsUrl = newUrl;
                                                                        row.documentsGuid = guid;
                                                                        applyVisualChanges()
                                                                    }}
                                                                    onFileDelete={() => {
                                                                        row.documentsUrl = null;
                                                                        row.documentsGuid = null;
                                                                        applyVisualChanges();
                                                                    }}/>
                                                : <></>}


                                        {props.controlType === 3 || props.controlType === 4
                                            ? <><TextField value={row.theme}
                                                           size={"small"}
                                                           placeholder={"Тема работы"}
                                                           onInput={(event) => {
                                                               row.theme = event.target.value;
                                                               applyVisualChanges();
                                                           }}/></>
                                            : <></>}
                                    </Stack>
                                </TableCell>
                                : <></>}
                            {!props.useStatementsView && props.noExtraGrade !== true
                                ? (<TableCell>
                                    <Stack spacing={2}>
                                        <ToggleButtonGroup orientation="horizontal"
                                                           fullWidth
                                                           size={"small"}
                                                           exclusive
                                                           value={extraGrade}
                                                           aria-label="Доп. оценка"
                                                           color="primary"
                                                           onChange={(event, value) => handleExtraGradeChange(row, value)}>
                                            <ToggleButton value={5} area-label="Отлично"
                                                          color="success">5</ToggleButton>
                                            <ToggleButton value={4} area-label="Хорошо" color="success">4</ToggleButton>
                                            <ToggleButton value={3} area-label="Удовлетворительно"
                                                          color="warning">3</ToggleButton>
                                            <ToggleButton value={2} area-label="Неудовлетворительно"
                                                          color="error">2</ToggleButton>
                                            <ToggleButton value={6} area-label="н/д" color="error">н/д</ToggleButton>
                                            <ToggleButton value={1} area-label="-" color="info">-</ToggleButton>
                                        </ToggleButtonGroup>

                                        <FormControl
                                            size={"small"}
                                            fullWidth>
                                            <InputLabel id="extra-grade-type-select-label">Тип оценки</InputLabel>
                                            <Select
                                                action={action}
                                                labelId="extra-grade-type-select-label"
                                                id="extra-grade-type-simple-select"
                                                label="Тип оценки"
                                                value={extraGradeType}
                                                onChange={(event, value) => setExtraGradeType(row, event.target.value)}
                                            >
                                                <MenuItem value={0}>Не указано</MenuItem>
                                                <MenuItem value={1}>Тестирование</MenuItem>
                                                <MenuItem value={2}>Лабораторная работа</MenuItem>
                                                <MenuItem value={3}>Контрольная работа</MenuItem>
                                                <MenuItem value={4}>Расчетно-графическая работа</MenuItem>
                                                <MenuItem value={5}>Домашнее задание</MenuItem>
                                                <MenuItem value={6}>Другое</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Stack>
                                </TableCell>)
                                : (null)}
                            {!props.useStatementsView
                                ? (<TableCell>
                                    <Checkbox checked={attended}
                                              onChange={(event, value) => attendedChanged(row, value)}/>
                                </TableCell>)
                                : (null)}
                            {isCourseWork()
                                ? <TableCell>
                                    <FileUploadButton existingFileUrl={row.reviewFileUrl}
                                                      existingFileGuid={row.reviewFileGuid}
                                                      maxFileSize={200 * 1024}
                                                      title={'Рецензия'}
                                                      uploadingEnabled
                                                      onFileUploaded={(newUrl, guid) => {
                                                          row.reviewFileUrl = newUrl;
                                                          row.reviewFileGuid = guid;
                                                          applyVisualChanges()
                                                      }}
                                                      onFileDelete={() => {
                                                          row.reviewFileUrl = null;
                                                          row.reviewFileGuid = null;
                                                          applyVisualChanges();
                                                      }}/>

                                    <FileUploadButton existingFileUrl={row.courseWorkFileUrl}
                                                      existingFileGuid={row.courseWorkFileGuid}
                                                      maxFileSize={1.5 * 1024 * 1024}
                                                      title={'Работа'}
                                                      uploadingEnabled
                                                      onFileUploaded={(newUrl, guid) => {
                                                          row.courseWorkFileUrl = newUrl;
                                                          row.courseWorkFileGuid = guid;
                                                          applyVisualChanges()
                                                      }}
                                                      onFileDelete={() => {
                                                          row.courseWorkFileUrl = null;
                                                          row.courseWorkFileGuid = null;
                                                          applyVisualChanges();
                                                      }}/>
                                </TableCell>
                                : <></>}
                        </TableRow>);
                    })}
                </TableBody>
            </Table>
        </Stack>
    );
}
